<div class="json-editor-container">
    <div class="json-editor-toggle">
        <label class="m-radio m-radio--solid m-radio--state-brand mr-3">
            <input type="radio" [name]="'viewType_' + uniqueId" value="json"
                   [checked]="viewType === 'json'" (change)="selectViewType('json')"> JSON
            <span></span>
        </label>
        <label class="m-radio m-radio--solid m-radio--state-brand">
            <input type="radio" [name]="'viewType_' + uniqueId" value="editor"
                   [checked]="viewType === 'editor'" (change)="selectViewType('editor')"> 에디터
            <span></span>
        </label>
    </div>

    <!-- JSON View -->
    <div class="ace-editor-wrapper" *ngIf="viewType === 'json'">
        <button *ngIf="showCopyButton" class="copy-btn" type="button" (click)="copyToClipboard()" title="복사">
            <i class="la la-copy"></i>
        </button>
        <ace [config]="aceConfig" [value]="value" (valueChange)="onJsonChange($event)"></ace>
    </div>

    <!-- Editor View -->
    <div class="meta-editor" *ngIf="viewType === 'editor'">
        <div class="meta-editor-row"
             *ngFor="let field of editorData; let i = index"
             [ngClass]="'array-group-' + getArrayGroupIndex(field.key)">
            <input type="text" class="form-control meta-key"
                   [(ngModel)]="field.key"
                   (ngModelChange)="onFieldChange()"
                   [placeholder]="parsingStrategy === 'array-expanded' ? '키 (예: items[0].id)' : '키 (중첩: parent.child)'" />
            <input type="text" class="form-control meta-value"
                   [(ngModel)]="field.value"
                   (ngModelChange)="onFieldChange()"
                   placeholder="값" />
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeField(i)">
                <i class="la la-trash"></i>
            </button>
        </div>
        <button type="button" class="btn btn-sm btn-outline-success mt-2" (click)="addField()">
            <i class="la la-plus"></i> 필드 추가
        </button>
    </div>
</div>
